/**
 * Wholesale Registration Form - Autofill Shipping Address
 * Automatically copies customer name and company to shipping address fields
 * Waits for Shopify Form #795314 to load before initializing
 */

(function() {
  'use strict';

  // Field mappings: source -> target
  const fieldMappings = {
    'first_name': 'shipping_address_first_name',
    'last_name': 'shipping_address_last_name',
    'company_name': 'shipping_address_recipient'
  };

  const SHOPIFY_FORM_ID = '795314';

  // Helper function to find shadow DOM element
  function findInShadowDOM(elementId) {
    // First check normal DOM
    let element = document.getElementById(elementId);
    if (element) return element;

    // Search in all shadow roots
    const allElements = document.querySelectorAll('*');
    for (let el of allElements) {
      if (el.shadowRoot) {
        element = el.shadowRoot.getElementById(elementId);
        if (element) return element;
      }
    }
    return null;
  }

  function setupAutofill() {
    // Find all source and target fields (checking shadow DOM)
    const fields = {};
    let allFieldsFound = true;

    // Check if all required fields exist
    Object.keys(fieldMappings).forEach(sourceId => {
      const sourceField = findInShadowDOM(sourceId);
      const targetField = findInShadowDOM(fieldMappings[sourceId]);

      if (sourceField && targetField) {
        fields[sourceId] = {
          source: sourceField,
          target: targetField
        };
      } else {
        allFieldsFound = false;
      }
    });

    if (!allFieldsFound) {
      return false;
    }

    // Setup autofill for each mapping
    Object.keys(fields).forEach(sourceId => {
      const { source, target } = fields[sourceId];

      // Copy value on input (real-time as user types)
      source.addEventListener('input', function() {
        target.value = this.value;
        // Trigger change event in case Shopify Forms needs it
        target.dispatchEvent(new Event('input', { bubbles: true }));
        target.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Also copy on blur (when field loses focus)
      source.addEventListener('blur', function() {
        target.value = this.value;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Copy existing value if source already has data (e.g., browser autofill)
      if (source.value) {
        target.value = source.value;
      }
    });

    return true;
  }

  function initAutofill() {
    // Try immediate setup
    if (setupAutofill()) {
      return;
    }

    // If fields not found, wait for Shopify Forms to inject them
    const observer = new MutationObserver(function(mutations, obs) {
      if (setupAutofill()) {
        obs.disconnect();
      }
    });

    // Observe the entire document for form injection
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Timeout after 5 seconds to prevent infinite observation
    setTimeout(function() {
      observer.disconnect();
      if (!setupAutofill()) {
        console.error('[Wholesale Autofill] Failed to initialize - form fields not found');
      }
    }, 5000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutofill);
  } else {
    initAutofill();
  }
})();
